import ReactGA from 'react-ga4';

/**
 * Initialize GA4 with the tracking ID from environment variables.
 * Only initializes if VITE_GA_TRACKING_ID is provided.
 */
export const initGA = () => {
  const trackingId = import.meta.env.VITE_GA_TRACKING_ID;
  if (trackingId) {
    ReactGA.initialize(trackingId);
    if (import.meta.env.DEV) {
      console.log('GA4 Initialized:', trackingId);
    }
  }
};

/**
 * Track a page view manually if needed.
 * @param {string} path - The path to track.
 */
export const trackPageView = (path) => {
  const trackingId = import.meta.env.VITE_GA_TRACKING_ID;
  if (trackingId) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

/**
 * Track a custom event.
 * @param {string} category - The category of the event (e.g., 'Video')
 * @param {string} action - The action taken (e.g., 'Export Start')
 * @param {string} label - Optional label for the event
 * @param {number} value - Optional numeric value for the event
 */
export const trackEvent = (category, action, label = '', value = 0) => {
  const trackingId = import.meta.env.VITE_GA_TRACKING_ID;
  if (trackingId) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};

export default {
  initGA,
  trackPageView,
  trackEvent,
};
